<template>

    <a :title="language.skip_and_move_to_next" @keydown.enter="goToNext" @click="goToNext" class="skip-to-next-slides allowtab" tabindex="1">{{ language.skip_and_move_to_next }}</a>

</template>


<script>

import dataStore from "../../store";

import { goToNextSlide } from './../../functions'

export default {

    inject: [ 'language' ],

    data() {
        return {
            dataStore
        };
    },

    methods: {

        goToNext: function(event) {
            goToNextSlide()
        }

    }
};
</script>
